import React from 'react'
import Modal from 'react-modal'
import {UniLink} from '../unilink/index'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ic_x_bk from '../../img/ic_x_bk.svg'
import './modal.css'

const asModal = (Component, modalLabel, asPanel=false) => {
  return props => {
    if (asPanel) {
      const shouldTransition = typeof props.shouldTransition !== 'undefined' ? props.shouldTransition : true
      const overlayBaseClassname = shouldTransition ? 'modalPanelOverlay' : 'modalPanelOverlay modalOverlay--after-open'
      const modalBaseClassname = shouldTransition ? 'modalPanel' : 'modalPanel modal--after-open'
      return (
        <Modal
          isOpen={true}
          onRequestClose={props.hideModal}
          appElement={document.getElementById('root')}
          contentLabel={modalLabel}
          className={{
            base: modalBaseClassname,
            afterOpen: 'modal--after-open',
            beforeClose: 'modal--before-close'
          }}
          overlayClassName={{
            base: overlayBaseClassname,
            afterOpen: 'modalOverlay--after-open',
            beforeClose: 'modalOverlay--before-close'
          }}
        >
          <Component {...props} />
        </Modal>
      )
    } else {
      const shouldTransition = typeof props.shouldTransition !== 'undefined' ? props.shouldTransition : true
      const overlayBaseClassname = shouldTransition ? 'modalOverlay' : 'modalOverlay modalOverlay--after-open'
      const modalBaseClassname = shouldTransition ? 'modal' : 'modal modal--after-open'
      return (
        <Modal
          isOpen={true}
          onRequestClose={props.hideModal}
          appElement={document.getElementById('root')}
          contentLabel={modalLabel}
          className={{
            base: modalBaseClassname,
            afterOpen: 'modal--after-open',
            beforeClose: 'modal--before-close'
          }}
          overlayClassName={{
            base: overlayBaseClassname,
            afterOpen: 'modalOverlay--after-open',
            beforeClose: 'modalOverlay--before-close'
          }}
        >
          <UniLink
            onClick={props.hideModal}
            className='modal__close'>
            <img src={ ic_x_bk } alt=""/>
          </UniLink>
          <Component {...props} />
        </Modal>
      )
    }

  }
}

export default asModal



// WEBPACK FOOTER //
// ./src/core/components/modals/AsModal.js